"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteDropZone = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var model_1 = require("../../model");
var debug_1 = require("./debug");
var useDashboardDrop_1 = require("./useDashboardDrop");
function DeleteDropZone() {
    var dispatch = model_1.useDashboardDispatch();
    var _a = tslib_1.__read(useDashboardDrop_1.useDashboardDrop("attributeFilter", {
        drop: function (_a) {
            var filter = _a.filter;
            var identifier = filter.attributeFilter.localIdentifier;
            dispatch(model_1.removeAttributeFilter(identifier));
        },
    }, [dispatch]), 2), _b = _a[0], canDrop = _b.canDrop, isOver = _b.isOver, dropRef = _a[1];
    if (!canDrop) {
        return null;
    }
    var className = classnames_1.default("gd-dropzone", "gd-dropzone-delete", {
        "gd-dropzone-over": isOver,
    });
    var debugStyle = debug_1.getDropZoneDebugStyle({ isOver: isOver });
    return (react_1.default.createElement("div", { className: className, ref: dropRef, style: debugStyle },
        react_1.default.createElement("div", { className: "gd-dropzone-message" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "addPanel.deleteItem" }))));
}
exports.DeleteDropZone = DeleteDropZone;
//# sourceMappingURL=DeleteDropZone.js.map